import { render, staticRenderFns } from "./DashboardStatsActivity.vue?vue&type=template&id=b73654a0&"
import script from "./DashboardStatsActivity.vue?vue&type=script&lang=js&"
export * from "./DashboardStatsActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports